export const QuestionMethodMapping = {
  "question-1-option-1": "Regenerante (Hairloss Control)",
  "question-1-option-2": "Clarifiante",
  "question-1-option-3": "Sensitive (Dandruff)",
  "question-1-option-4": "Sensitive (Sensitive)",
};

export const QuestionSolutionMapping = {
  "question-2-option-1": "Structure Repair",
  "question-2-option-2": "Volume",
  "question-2-option-3": "Frizz Control",
  "question-2-option-4": "Curl",
  "question-2-option-5": "Colour Protection",
};
